import { useState } from 'react';
import { hooks as commonHooks } from '@sitebuilder/common';
import TableRow from './TableRow';
import { FirstColumnOption } from './utils';

interface PropsShape {
    id: string;
    label: string;
    firstColumnOptions?: FirstColumnOption;
    columns: { id: string; label: string }[];
    rows: any[];
    checkList: string[];
    setCheckList: (checkList: string[]) => void;
    iconShowContent?: string;
    iconHideContent?: string;
    fundUrlMapping: {
        parameters: {
            key: string;
            value: string;
        }[];
        fundUrlTag: string;
    }[];
    fundUrl: string;
    fundUrlBase: string;
    fundPdfUrlBase: string;
    fundPdfName: string;
    setFavorites: (favorites: string[]) => void;
    dataContext: any;
    selectedListStorageName?: string;
    selectedListDataId?: string;
    maxSelectionList?: number;
    selectedListJsonPath?: string;
    disableCheckbox?: boolean;
    setDisableCheckbox: (checked: boolean) => void;
    disableTabStaticData?: boolean;
}

export default function TableRowGroup(props: PropsShape) {
    const {
        id,
        label,
        columns,
        rows,
        checkList,
        setCheckList,
        firstColumnOptions,
        dataContext,
        fundUrlMapping,
        fundUrlBase,
        fundPdfUrlBase,
        fundPdfName,
        setDisableCheckbox,
        disableTabStaticData,
        ...rest
    } = props;

    const i18n = commonHooks.useLocalization();

    const [isExpanded, setIsExpanded] = useState(true);
    const toggleGroup = () => setIsExpanded(!isExpanded);

    // Compose toggle classes and labels
    let toggleClassName = 'row-group-toggle-icon ';
    let toggleLabel;

    if (isExpanded) {
        toggleClassName += rest.iconHideContent;
        toggleLabel = i18n.t('widgets_fundList_rowGroups_collapse');
    } else {
        toggleClassName += rest.iconShowContent;
        toggleLabel = i18n.t('widgets_fundList_rowGroups_expand');
    }

    return (
        <>
            <tr data-group-id={id} className="row--group">
                {/* The + 1 is to account for the select all checkbox */}
                <td colSpan={columns.length + 1}>
                    <button
                        className="icon-button row-group-toggle"
                        type="button"
                        onClick={toggleGroup}
                    >
                        <i className={toggleClassName} />
                        {label}{' '}
                        {i18n.t({
                            key: 'widgets_fundList_rowGroups_numFundsInGroup',
                            values: { count: `${rows.length}` },
                        })}
                        <span className="sr-only">{toggleLabel}</span>
                    </button>
                </td>
            </tr>
            {isExpanded
                ? rows.map((o, index) => (
                      // TODO: use entity id in the future, when it's actually unique
                      <TableRow
                          key={o.id}
                          isLastRow={index === rows?.length - 1}
                          firstColumnOptions={firstColumnOptions}
                          columns={columns}
                          data={o}
                          checkList={checkList}
                          setCheckList={setCheckList}
                          fundUrlMapping={fundUrlMapping}
                          fundUrl={rest.fundUrl}
                          fundUrlBase={fundUrlBase}
                          fundPdfUrlBase={fundPdfUrlBase}
                          fundPdfName={fundPdfName}
                          setFavorites={rest.setFavorites}
                          dataContext={dataContext}
                          selectedListStorageName={rest.selectedListStorageName}
                          selectedListDataId={rest.selectedListDataId}
                          maxSelectionList={rest.maxSelectionList}
                          selectedListJsonPath={rest.selectedListJsonPath}
                          disableCheckbox={rest.disableCheckbox}
                          setDisableCheckbox={setDisableCheckbox}
                          disableTabStaticData={disableTabStaticData}
                      />
                  ))
                : null}
        </>
    );
}
